<app-navbar></app-navbar>

<div class="register-page-wrapper">
  <div class="register-page-background"></div>
  <div class="register-page-content container">
    <!-- Your existing content here -->


<br><br><br>
<div class="register-page-content container">
  <div class="container">
    <div class="justify-content-center row">
      <div class="col-lg-5">
        <div class="login-card">
          <div class="bg-white pb-5 card-header">
            <div class="login-img">
              <div class="login-img_container">
                <img src="assets/img/logo.png" alt="kharaaj" />
              </div>
            </div>
          </div>
          <div class="mt-3 px-lg-5 py-lg-5 card-body">
            <div class="text-login text-muted text-right">
              <div class="text-login_welcome">مرحباً بك</div>
              <div class="mb-3 text-login_desc">
                خراج أول منصة لبيع المنتجات الزراعية بالجملة 
              </div>
            </div>
            
            <!-- User Type Selection -->
            <div class="mb-4 user-type-selection">
              <div class="btn-group w-100" role="group">
                <button type="button" 
                        class="btn-outline-primary btn"
                        [class.active]="selectedType === userTypes.BUYER || selectedType === userTypes.SELLER"
                        (click)="setRegisterType('BUYER')">
                  مشتري/بائع
                </button>
                <button type="button" 
                        class="btn-outline-primary btn"
                        [class.active]="selectedType === userTypes.TRANSPORTER || 
                                        selectedType === userTypes.TRANSPORTER_AGENT || 
                                        selectedType === userTypes.TRANSPORTER_COMPANY"
                        (click)="setRegisterType('TRANSPORTER')">
                  ناقل
                </button>
              </div>
            </div>

            <form class="login-form" role="form" [formGroup]="loginForm" (submit)="onSubmit()">
              <div class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text phone-code">{{ phoneCode }}</span>
                  </div>
                  <input formControlName="phoneNumber"
                        class="form-control"
                        placeholder="إدخال رقم الهاتف"
                        pattern="\d*"
                        [maxlength]="phoneLength"
                        type="tel" />
                </div>
              </div>

              <div *ngIf="selectedType === userTypes.MARKETER" class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <input formControlName="pairingCode"
                        class="form-control"
                        placeholder="رقم الإقتران أو رقم الهاتف"
                        type="text" />
                </div>
              </div>

              <div *ngIf="showPasswordField()" class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <input formControlName="pwd"
                        class="form-control"
                        placeholder="كلمة المرور"
                        type="password" />
                </div>
                <br />
                <a href="auth/forget-password" class="forgot-password-link">
                  نسيت كلمة السر؟
                </a>
              </div>

              <div class="text-center login-form_bottom">
                <button type="submit"
                        class="my-4 btn btn-primary login-btn"
                        [disabled]="loginForm.invalid">
                  تسجيل الدخول
                </button>
                <div class="register-link">
                  <a [routerLink]="APP_ROUTES.AUTH.REGISTER"
                    [queryParams]="{ type: selectedType }"
                    class="text-black c-pointer">
                    <small>إنشاء حساب ؟</small>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>
</div>

